import { motion } from 'framer-motion';
import styles from './Spinner.module.css';

const Spinner = ({ variant }) => {
  return (
    <div className={`${styles.spinnerWrapper} ${styles[variant]}`}>
      <motion.div
        className={styles.arc}
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          duration: 1,
          ease: "linear",
        }}
      ></motion.div>
    </div>
  );
};

export default Spinner;
